import { useEffect, useState } from 'react';
import {
  CookieConsent,
  getCookieConsent,
  setCookieConsent,
  subscribeCookieConsent,
} from '@/lib/cookieConsent';

export function useCookieConsent() {
  const [consent, setConsent] = useState<CookieConsent | null>(() =>
    typeof document === 'undefined' ? null : getCookieConsent()
  );

  useEffect(() => subscribeCookieConsent(() => setConsent(getCookieConsent())), []);

  return {
    consent,
    granted: consent === 'accepted',
    accept: () => setCookieConsent('accepted'),
    deny: () => setCookieConsent('denied'),
  };
}
